import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-p-triangle",
  "use": "icon-p-triangle-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol viewBox=\"0 0 26 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-p-triangle\">\n<g id=\"icon-p-triangle_Frame\">\n<path id=\"icon-p-triangle_Vector\" d=\"M4.25037 23.3338L11.8931 4.51028L22.4726 23.3338H4.25037Z\" fill-opacity=\"0.5\" stroke=\"white\" stroke-width=\"0.8\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol